import { CatalogItem } from 'entities/CatalogItem/model/types/CatalogItemSchema';
import { HydratedProposal } from 'entities/Proposal/model/types/ProposalSchema';
import { VendorActivationStatus } from 'entities/Vendors';

export const proposalIsOutOfStock = (
    proposal: HydratedProposal,
    selectedItem: CatalogItem,
): boolean => {
    return (
        selectedItem.isCheckFinished &&
        (!proposal.availableQuantity || proposal.availableQuantity === 0)
    );
};

export const proposalIsOverStock = (
    proposal: HydratedProposal,
    getSupplierQuantity: (uid: string) => number,
): boolean => {
    return getSupplierQuantity(proposal.uid) > proposal.availableQuantity;
};

export const proposalSupplierIsInVerifying = (
    proposal: HydratedProposal,
): boolean => {
    return (
        proposal.hydratedVendor?.operationsAccountStatus ===
        VendorActivationStatus.VERIFYING
    );
};

export const proposalSupplierIsInRejected = (
    proposal: HydratedProposal,
): boolean => {
    return (
        proposal.hydratedVendor?.operationsAccountStatus ===
        VendorActivationStatus.INVALID
    );
};
